import LiquidacionJugadorCreateView from './views/LiquidacionJugadorCreateView.vue'
import LiquidacionesJugadoresListView from './views/LiquidacionesJugadoresListView.vue'
import LiquidacionesJugadoresView from './views/LiquidacionesJugadoresView.vue'

export default [
  {
    path: '/liquidacionjugador-nueva',
    name: 'nuevaLiquidacionJugador',
    component: LiquidacionJugadorCreateView
  },
  {
    path: '/liquidacionesjugadores',
    name: 'liquidacionesJugadores',
    component: LiquidacionesJugadoresListView
  },
  {
    path: '/liquidacionjugador/:id',
    name: 'detalleLiquidacionJugador',
    component: LiquidacionesJugadoresView
  }
]
